import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import type { SxProps, Theme } from '@mui/material/styles';
import { COVERAGE_DISPLAY_LABELS } from '@shared/constants/coverage';

interface Props {
  value: string[];
  onChange: (values: string[]) => void;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

export default function CoverageFilter({ value, onChange, size = 'small', sx }: Props) {
  function handleChange(event: SelectChangeEvent<string[]>) {
    const v = event.target.value;
    onChange(typeof v === 'string' ? v.split(',') : v);
  }

  return (
    <FormControl size={size} sx={[{ width: '100%' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
      <InputLabel>Coverage</InputLabel>
      <Select
        multiple
        value={value}
        onChange={handleChange}
        label="Coverage"
        renderValue={(selected) => selected.map((v) => COVERAGE_DISPLAY_LABELS[v] ?? v).join(', ')}
      >
        {Object.entries(COVERAGE_DISPLAY_LABELS).map(([key, label]) => (
          <MenuItem key={key} value={key}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
